import React from "react";
import styled from "styled-components";
import { setColor } from "../../../assets/styles/styles";

const ToggleSwitch = ({ value, onChange, disabled }) => (
    <>
        <SwitchContainer disabled={disabled}>
            <HiddenCheckbox checked={value} onChange={() => onChange(!value)} disabled={disabled} />
            <Slider isChecked={value} disabled={disabled} />
        </SwitchContainer>
    </>
);

export default ToggleSwitch;

const getBackgroundColor = (props) => {
    if (props.isChecked) {
        return setColor.aquaGreen;
    }
    return setColor.redLightWarning;
};

const SwitchContainer = styled.label`
    position: relative;
    display: inline-block;
    width: 55px;
    height: 25px;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
    opacity: ${(props) => (props.disabled ? 0.6 : 1)};
`;

const Slider = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    transition: background-color 0.4s ease;
    border-radius: 85px;
    background-color: ${getBackgroundColor};
    &::before {
        position: absolute;
        content: "";
        height: 18px;
        width: 18px;
        left: 4px;
        bottom: 4px;
        background-color: white;
        transition: transform 0.4s ease;
        border-radius: 50%;
        transform: ${(props) => (props.isChecked ? "translateX(26px)" : "translateX(0)")};
    }
`;

const HiddenCheckbox = styled.input.attrs({ type: "checkbox" })`
    opacity: 0;
    width: 0;
    height: 0;
    cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
`;
